/* eslint-disable no-undef */
import React from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import ReactOnRails from 'react-on-rails';
import MainLayout from '../../containers/MainLayout/MainLayout';

import skyline from '../../../../assets/images/white_skyline.svg';
import notFoundErrorIcon from '../../../../assets/images/404-pin.svg';
import serverErrorIcon from '../../../../assets/images/500-pin.svg';

import frontpageIcon from '../../../../assets/images/frontpage.svg';
import becomeProviderIcon from '../../../../assets/images/become-provider.svg';

import './style.sass';

const ErrorPage = (props) => {
  const appStore = ReactOnRails.getStore('appStore');
  const {
    paths,
    footerData,
  } = props;

  const siteName = props.siteName.charAt(0).toUpperCase() + props.siteName.slice(1);

  let errorIcon;
  let pageTitle;
  let pageText;

  switch (props.errorType) {
    case 'server_error':
      errorIcon = serverErrorIcon;
      pageTitle = I18n.t('error_page.server_error.title');
      pageText = I18n.t('error_page.server_error.text');
      break;
    default:
      errorIcon = notFoundErrorIcon;
      pageTitle = I18n.t('error_page.not_found.title');
      pageText = I18n.t('error_page.not_found.text');
  }

  return (
    <div>
      <Provider store={appStore}>
        <MainLayout footerData={footerData}>
          <div className="error-page">
            <div className="error-page__header-wrapper">
              <div className="container">
                <div className="error-page__header-container">
                  <div
                    className="error-page__header-icon error-page__header-bg"
                    style={{ backgroundImage: `url(${errorIcon})` }}
                  />
                  <h1 className="main-color bold">{pageTitle}</h1>
                  <div className="error-page__header-text">{pageText}</div>
                </div>
              </div>
              <div
                className="error-page__header-skyline error-page__header-bg"
                style={{ backgroundImage: `url(${skyline})` }}
              />
            </div>

            <div className="container">
              <h3
                className="main-color bold error-page__actions-title"
              >
                {I18n.t('error_page.general.actions_title')}
              </h3>
              <div className="error-page__actions">
                <div className="error-page__action">
                  <div className="error-page__action-body">
                    <div
                      className="error-page__action-icon"
                      style={{ backgroundImage: `url(${frontpageIcon})` }}
                    />
                    <h3 className="main-color bold tac">{I18n.t('error_page.general.go_to_front')}</h3>
                    <p className="tac">{I18n.t('error_page.general.go_to_front_text')}</p>
                  </div>
                  <a href={paths.root} className="button--big-orange">
                    {I18n.t('error_page.general.go_to_front_button')}
                  </a>
                </div>
                <div className="error-page__action">
                  <div className="error-page__action-body">
                    <div
                      className="error-page__action-icon"
                      style={{ backgroundImage: `url(${becomeProviderIcon})` }}
                    />
                    <h3 className="main-color bold tac">{I18n.t('error_page.general.list_office')}</h3>
                    <p className="tac">{I18n.t('error_page.general.list_office_text', { site: siteName })}</p>
                  </div>
                  <a
                    href={paths.signupTeaser}
                    className="button--big-orange"
                  >
                    {I18n.t('error_page.general.list_office_button')}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </MainLayout>
      </Provider>
    </div>
  );
};

ErrorPage.propTypes = {
  siteName: PropTypes.string,
  errorType: '',
  paths: PropTypes.oneOfType([PropTypes.object]),
  footerData: PropTypes.oneOfType([PropTypes.object]),
};

ErrorPage.defaultProps = {
  siteName: '',
  errorType: '',
  paths: {},
  footerData: {},
};

export default ErrorPage;
